import React, { useEffect, useState } from 'react';

import { AddCardInfoModal } from '../../common/AddCardInfoModal';
import { AddNewBipCard } from '../../common/AddNewBipCard';
import { AddNewCard } from '../../common/AddNewCard';
import ApiUrls from '../../../services/apiUrls';
import { AppData } from '../../../services';
import BIP from './components/BIP';
import { BipComingSoonModal } from '../../common/BipComingSoonModal';
import CommonService from '../../../services/commonService';
import { DeleteBipCard } from '../../common/DeleteBipCard';
import { DeleteCard } from '../../common/DeleteCard';
import { EditBipCard } from '../../common/EditBipCard';
import { EditCard } from '../../common/EditCard';
import EnvironmentalImpact from './components/EnvironmentalImpact';
import { KuposErrorSuccessModal } from '../../common';
import MenuItems from './components/MenuItems';
import MyCards from './components/MyCards';
import QrImage from './components/QrImage';

function MainTabsBodyMyAccount(props) {
  let track = null;
  const [items, setItems] = useState([
    { icon: '/images/circular/qr.png', label: 'MY_QR' },
    // { icon: '/images/icon_bip.png', label: 'MY_BIP' },
    { icon: '/images/circular/trips.png', label: 'MY_TRAVELS' },
    { icon: '/images/icons/home/icon_credit_card.png', label: 'MY_CARDS' },
    // { icon: '/images/circular/piggy-bank.png', label: 'MY_STATISTICS' },
    { icon: '/images/circular/enfironment.png', label: 'ENVIRONMENTAL_EFFECTS' },
  ]);
  const [bipItems, setBipItems] = useState([]);
  const [titleDescItems, setTitleDescItems] = useState([
    { title: 'PROFILE.KM_RECORDED', desc: '150' },
    { title: 'PROFILE.CO2_SAVED', desc: '7.3M' },
    { title: 'PROFILE.PLANTED_TREES', desc: '1.23M' },
    { title: 'PROFILE.SAVED_MONEY', desc: 'CLP $6000' },
  ]);
  const [envItems, setEnvItems] = useState([
    {
      date: '30-04-2020',
      img: '/images/circular/enfironment.png',
      service: 'KuposPool',
      region: 'Santiago Centro - Quinta Normal',
      percentage: '90',
    },
    {
      date: '30-04-2020',
      img: '/images/circular/enfironment.png',
      service: 'TrenCentral',
      region: 'Santiago Centro - Quinta Normal',
      percentage: '80',
    },
  ]);
  const [myCards, setMyCards] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [bipAdminScreen, setBipAdminScreen] = useState(false);
  const [showDeleteBIPCard, setShowDeleteBIPCard] = useState(false);
  const [showEditBipCard, setShowEditBipCard] = useState(false);
  const [showAddBIPCard, setShowAddBIPCard] = useState(false);
  const [selectedItemForDeletion, setSelectedItemForDeletion] = useState(null);
  const [selectedItemForEdit, setSelectedItemForEdit] = useState(null);
  const [noCards, setNoCards] = useState(true);
  const [cardInFocus, setCardInFocus] = useState(0);
  const [bipCardToEdit, setBipCardToEdit] = useState(null);
  const [bipCardToDelete, setBipCardToDelete] = useState(null);
  const [cardTypes, setCardTypes] = useState(props.metaData ? props.metaData.card_type : null);
  const [showSuccessFailureModal, setShowSuccessFailureModal] = useState(null);
  const [showSuccessFailureModalStatus, setShowSuccessFailureModalStatus] = useState(null);
  const [showSuccessFailureModalBodyText, setShowSuccessFailureModalBodyText] = useState(null);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [showPaymentsOptions, setShowPaymentsOptions] = useState(null);
  const [envData, setEnvData] = useState(null);
  const [bipComingSoonModal, setBipComingSoonModal] = useState(null);
  const [bipRechargeAmount, setBipRechargeAmount] = useState(null);
  const [bipRechargeAmountError, setBipRechargeAmountError] = useState(null);
  const [showCardAddInfoModal, setShowCardAddInfoModal] = useState(null);
  const [showDeleteCard, setShowDeleteCard] = useState(null);
  const [showAddCard, setShowAddCard] = useState(null);
  const [showEditCard, setShowEditCard] = useState(null);
  const [selectedItemForEditAddCard, setSelectedItemForEditAddCard] = useState(null);
  const [initialRender, setInitialRender] = useState(true);

  const getBipCards = () => {
    props.actions
      .apiCall({
        url: AppData.BIP_URL + 'api/v1/myCard/' + props.data.loginData.id,
      })
      .then(
        (res) => onBipCardsFetchResponse(res),
        (err) => onBipCardsFetchResponse(err),
      );
  };

  // COMPONENT DID MOUNT
  useEffect(() => {
    getBipCards();
    props.actions.getProfile({ url: ApiUrls.profile() }).then(
      (res) => {
        if (res && res.error) {
          return;
        } else if (res && res.auth_token) {
          CommonService.storeLoginDetails(res, props.actions.setLoginData);
        }
      },
      (err) => {
        if (err && err.status && err.status == 401) {
          CommonService.logout();
          props.history.push('/');
        }
      },
    );

    props.actions.apiCall({ url: AppData.BASE_URL + 'api/env_stats', type: 'home' }).then(
      (res) => onEnvDataFetch(res),
      (err) => onEnvDataFetch(err),
    );

    getOneClickCards();
  }, []);

  const getOneClickCards = () => {
    //Get one click cards
    props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/my_cards_list',
        type: 'home',
      })
      .then(
        (res) => onOneClickCardsFetch(res),
        (err) => onOneClickCardsFetch(err),
      );
  };

  const onOneClickCardsFetch = (result) => {
    if (result && result.data && result.data.card_details) {
      setMyCards(result.data.card_details);
    } else if (result.data.status === 401) {
      setMyCards([]);
    }

    setShowPaymentsOptions(true);
  };

  const onEnvDataFetch = (result) => {
    if (result && result.data) {
      setEnvData(result.data);
    }
  };

  const onBipCardsFetchResponse = (result) => {
    if (result && result.data && result.data.success && result.data.data) {
      setBipItems(result.data.data);
    }
  };

  const onItemClick = (val, i) => {
    if (val.label == 'MY_QR') {
      props.actions.getQr();
      setSelectedItem(val);
    } else if (val.label == 'MY_BIP') {
      setBipComingSoonModal(true);
    } else if (val.label === 'MY_TRAVELS') {
      props.onMenuChange(1);
    } else if (val.label == 'ENVIRONMENTAL_EFFECTS') {
      setSelectedItem(val);
    } else if (val.label == 'MY_CARDS') {
      setSelectedItem(val);
    }
  };

  const renderItemContent = () => {
    if (selectedItem.label == 'MY_QR') {
      return <QrImage t={props.t} setSelectedItem={setSelectedItem} data={props.data} />;
    } else if (selectedItem.label == 'MY_BIP') {
      return (
        <BIP
          bipItems={bipItems}
          bipAdminScreen={bipAdminScreen}
          setBipAdminScreen={setBipAdminScreen}
          setSelectedItem={setSelectedItem}
          setShowAddBIPCard={setShowAddBIPCard}
          setCardInFocus={setCardInFocus}
          bipRechargeAmountError={bipRechargeAmountError}
          bipRechargeAmount={bipRechargeAmount}
          onBipRechargeAmountBlur={onBipRechargeAmountBlur}
          onBipRechargeAmountChange={onBipRechargeAmountChange}
          goToBipRecharge={goToBipRecharge}
          showBipEditPopup={showBipEditPopup}
          showBipDeletePopup={showBipDeletePopup}
          cardInFocus={cardInFocus}
          track={track}
          t={props.t}
        />
      );
    } else if (selectedItem.label == 'ENVIRONMENTAL_EFFECTS') {
      return (
        <EnvironmentalImpact
          t={props.t}
          setSelectedItem={setSelectedItem}
          // renderTitleDesc={renderTitleDesc}
          titleDescItems={titleDescItems}
          envData={envData}
        />
      );
    } else if (selectedItem.label == 'MY_CARDS') {
      return (
        <MyCards
          t={props.t}
          setSelectedItem={setSelectedItem}
          myCards={myCards}
          setShowCardAddInfoModal={setShowCardAddInfoModal}
          cardTypes={cardTypes}
          setShowDeleteCard={setShowDeleteCard}
          setSelectedItemForDeletion={setSelectedItemForDeletion}
        />
      );
    }
  };

  const showBipEditPopup = (val) => {
    setBipCardToEdit(val);

    setTimeout(() => {
      setShowEditBipCard(true);
    }, 100);
  };

  const showBipDeletePopup = (val) => {
    setBipCardToDelete(val);

    setTimeout(() => {
      setShowDeleteBIPCard(true);
    }, 100);
  };

  const onBipRechargeAmountChange = (val) => {
    setBipRechargeAmount(val);
    setBipRechargeAmountError(null);
  };

  const onBipRechargeAmountBlur = (val) => {
    if (!val) {
      setBipRechargeAmountError({
        message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT',
      });
    }
  };

  const goToBipRecharge = () => {
    if (!bipRechargeAmount) {
      setBipRechargeAmountError({
        message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT',
      });
      return;
    }

    if (bipRechargeAmount < 2000 || bipRechargeAmount > 25000) {
      setBipRechargeAmountError({
        message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT_LIMIT',
      });
      return;
    }
    let data = {
      cardNumber: bipItems[cardInFocus].card_number,
      amount: bipRechargeAmount,
      email: bipItems[cardInFocus].email,
      confirmEmail: bipItems[cardInFocus].email,
      isMyCard: 'my_card',
    };
    props.actions.saveBipDetails(data);
    props.history.push('/bip-payment');
  };

  const onMonthChange = (maskedValue, selectedYear, selectedMonth) => {
    setSelectedYear(selectedYear);
    setSelectedMonth(selectedMonth);
  };

  const onAddBipCard = (result) => {
    setNoCards(false);

    if (result && result.data && result.data.success && result.data.data) {
      getBipCards();

      setShowAddBIPCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(true);
      setShowSuccessFailureModalBodyText('VALIDATIONS.BIP_CARD_ADDED');
    } else {
      setShowAddBIPCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(false);
      setShowSuccessFailureModalBodyText(
        result.data.message == 'Ingresa una tarjeta bip! válida.'
          ? 'VALIDATIONS.INVALID_BIP_CARD'
          : result.data.message,
      );
    }
  };

  const onBipCardUpdate = (result) => {
    if (result && result.data && result.data.success && result.data.data) {
      getBipCards();

      setShowEditBipCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(true);
      setShowSuccessFailureModalBodyText('VALIDATIONS.BIP_CARD_UPDATED');
    } else {
      setShowEditBipCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(false);
      setShowSuccessFailureModalBodyText(result.data.message || 'Failure!');
    }
  };

  const onBipCardDelete = (result) => {
    if (result && result.data && result.data.success && result.data.data) {
      getBipCards();

      setShowDeleteBIPCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(true);
      setShowSuccessFailureModalBodyText('VALIDATIONS.BIP_CARD_REMOVED');
    } else {
      setShowDeleteBIPCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(false);
      setShowSuccessFailureModalBodyText(result.data.message || 'Failure!');
    }
  };

  const onCardRemoved = (result) => {
    getOneClickCards();
    if (result && result.data && result.data.message === 'successfully Removed') {
      setShowDeleteCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(true);
      setShowSuccessFailureModalBodyText('TRANSLATIONS.CARD_REMOVED_SUCCESS');
    } else {
      setShowDeleteCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(false);
      setShowSuccessFailureModalBodyText('TRANSLATIONS.CARD_REMOVED_FAILURE');
    }
  };

  const addOneClickCard = () => {
    localStorage.setItem('appType', 'one_click');
    props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/kupos_add_cards',
        type: 'home',
        method: 'POST',
      })
      .then(
        (res) => onAddCard(res),
        (err) => onAddCard(err),
      );
  };

  const onAddCard = (result) => {
    if (result && result.data && result.data.html_str) {
      setShowCardAddInfoModal(false);
      localStorage.setItem('paymentGatewayOpened', true);
      document.write(result.data.html_str);
    }
  };
  const { t } = props;
  return (
    <div
      className={
        'sub-section-description scroll-style ' +
        (selectedItem && selectedItem.label == 'MY_BIP' ? 'bip-selection-container' : '')
      }
    >
      {selectedItem === null ? (
        <div className="my-account-title center-text">
          <div className="sub-section-account-general-title font13">
            {t('PROFILE.MY_MENUS_HEADING.NORMAL')}{' '}
            <span className="bold-text">{t('PROFILE.MY_MENUS_HEADING.BOLD')}</span>
          </div>
          <div className="sub-section-account-general-description font11">
            {t('PROFILE.MY_MENUS_DESCRIPTION')}
          </div>
        </div>
      ) : null}

      {selectedItem === null ? (
        <div className="sub-section-body">
          <div className="account-general-items font10 bold-text">
            {items.map((val, key) => (
              <MenuItems
                val={val}
                key={key}
                data={props.data}
                onItemClick={onItemClick}
                setShowSuccessFailureModal={setShowSuccessFailureModal}
                setShowSuccessFailureModalStatus={setShowSuccessFailureModalStatus}
                setShowSuccessFailureModalBodyText={setShowSuccessFailureModalBodyText}
                t={props.t}
              />
            ))}
          </div>
        </div>
      ) : (
        renderItemContent()
      )}

      <AddNewCard
        showModal={showAddCard}
        onHide={() => setShowAddCard(false)}
        common={props.common}
        onAddCard={() => {
          setNoCards(false);
          setShowAddCard(false);
        }}
        t={props.t}
      />

      <EditCard
        showModal={showEditCard}
        onHide={() => setShowEditCard(false)}
        userCards={myCards}
        selectedItemForEdit={selectedItemForEditAddCard}
        t={props.t}
      />

      <DeleteCard
        showModal={showDeleteCard}
        onHide={() => setShowDeleteCard(false)}
        userCards={myCards}
        selectedItemForDeletion={selectedItemForDeletion}
        data={props.data}
        actions={props.actions}
        t={props.t}
        onCardRemoved={onCardRemoved}
      />

      <BipComingSoonModal
        showModal={bipComingSoonModal}
        onHide={() => setBipComingSoonModal(false)}
        image={t('HOME.BIP_SOON_IMAGE')}
        metaData={props.metaData}
      />

      <AddNewBipCard
        showModal={showAddBIPCard}
        onHide={() => setShowAddBIPCard(false)}
        common={props.common}
        onAddCard={onAddBipCard}
        actions={props.actions}
        data={props.data}
        t={props.t}
      />

      {bipCardToEdit ? (
        <EditBipCard
          showModal={showEditBipCard}
          onHide={() => setShowEditBipCard(false)}
          userCards={bipItems}
          selectedItemForEdit={bipCardToEdit}
          onBipCardUpdate={onBipCardUpdate}
          data={props.data}
          actions={props.actions}
          t={props.t}
        />
      ) : null}

      {bipCardToDelete ? (
        <DeleteBipCard
          showModal={showDeleteBIPCard}
          onHide={() => setShowDeleteBIPCard(false)}
          userCards={bipItems}
          selectedItemForDeletion={bipCardToDelete}
          onBipCardDelete={onBipCardDelete}
          data={props.data}
          actions={props.actions}
          t={props.t}
        />
      ) : null}

      <KuposErrorSuccessModal
        success={showSuccessFailureModalStatus}
        showModal={showSuccessFailureModal}
        title={
          showSuccessFailureModalStatus ? props.t('HOME.THANK_YOU') : props.t('HOME.WE_ARE_SORRY')
        }
        onButtonClick={() => setShowSuccessFailureModal(false)}
        bodyText={showSuccessFailureModalBodyText}
        t={props.t}
        generalButton={showSuccessFailureModalStatus ? props.t('OK') : props.t('PROFILE.GO_BACK')}
      />

      <AddCardInfoModal
        showModal={showCardAddInfoModal}
        onHide={() => setShowCardAddInfoModal(false)}
        icon={'/images/warning.png'}
        t={props.t}
        addCard={addOneClickCard}
      />
    </div>
  );
}

export default MainTabsBodyMyAccount;

// export default class MainTabsBodyMyAccount extends Component {
//   static propTypes = {
//     t: PropTypes.func,
//     actions: PropTypes.object,
//     data: PropTypes.object,
//     onMenuChange: PropTypes.func,
//     history: PropTypes.object,
//   };

//   constructor(props) {
//     super(props);
//     this.state = {
//       items: [
//         { icon: '/images/circular/qr.png', label: 'MY_QR' },
//         { icon: '/images/icon_bip.png', label: 'MY_BIP' },
//         { icon: '/images/circular/trips.png', label: 'MY_TRAVELS' },
//         { icon: '/images/icons/home/icon_credit_card.png', label: 'MY_CARDS' },
//         { icon: '/images/circular/piggy-bank.png', label: 'MY_STATISTICS' },
//         { icon: '/images/circular/enfironment.png', label: 'ENVIRONMENTAL_EFFECTS' },
//       ],
//       bipItems: [],

//       // bipItems: [
//       //   { cardNumber: '87687638', name: 'Cecelia Castro' },
//       //   { cardNumber: '21231238', name: 'Amit Sodani' },
//       //   { cardNumber: '12673677', name: 'Somu Sekhar' },
//       //   { cardNumber: '98176238', name: 'Tanveer Ahmad' },
//       //   { cardNumber: '18727727', name: 'Pavan Kumar' },
//       // ],
//       titleDescItems: [
//         { title: 'PROFILE.KM_RECORDED', desc: '150' },
//         { title: 'PROFILE.CO2_SAVED', desc: '7.3M' },
//         { title: 'PROFILE.PLANTED_TREES', desc: '1.23M' },
//         { title: 'PROFILE.SAVED_MONEY', desc: 'CLP $6000' },
//       ],
//       envItems: [
//         {
//           date: '30-04-2020',
//           img: '/images/circular/enfironment.png',
//           service: 'KuposPool',
//           region: 'Santiago Centro - Quinta Normal',
//           percentage: '90',
//         },
//         {
//           date: '30-04-2020',
//           img: '/images/circular/enfironment.png',
//           service: 'TrenCentral',
//           region: 'Santiago Centro - Quinta Normal',
//           percentage: '80',
//         },
//       ],
//       myCards: [],
//       selectedItem: null,
//       bipAdminScreen: false,
//       showDeleteBIPCard: false,
//       showEditBipCard: false,
//       showAddBIPCard: false,
//       selectedItemForDeletion: null,
//       selectedItemForEdit: null,
//       noCards: true,
//       cardInFocus: 0,
//       bipCardToEdit: null,
//       bipCardToDelete: null,
//       cardTypes: this.props.metaData ? this.props.metaData.card_type : null,
//     };

//     this.getBipCards();
//   }

//   componentDidMount() {
//     console.log('Data =---------------------', this.state.cardTypes);
//     this.props.actions.getProfile({ url: ApiUrls.profile() }).then(
//       res => {
//         if (res && res.error) {
//           return;
//         } else if (res && res.auth_token) {
//           CommonService.storeLoginDetails(res, this.props.actions.setLoginData);
//         }
//       },
//       err => {
//         if (err.status == 401) {
//           CommonService.logout();
//           this.props.history.push('/');
//         }
//       },
//     );

//     console.log('Props are ----------main tabs bodxy----------', this.props);

//     this.props.actions.apiCall({ url: AppData.BASE_URL + 'api/env_stats', type: 'home' }).then(
//       res => this.onEnvDataFetch(res),
//       err => this.onEnvDataFetch(err),
//     );

//     this.getOneClickCards();
//   }

//   getOneClickCards = () => {
//     //Get one click cards
//     this.props.actions
//       .apiCall({
//         url: AppData.BASE_URL + 'api/my_cards_list',
//         type: 'home',
//       })
//       .then(
//         res => this.onOneClickCardsFetch(res),
//         err => this.onOneClickCardsFetch(err),
//       );
//   };

//   onOneClickCardsFetch = result => {
//     console.log('Cards detauls from backend ----------', result);
//     if (result && result.data && result.data.card_details) {
//       this.setState({ myCards: result.data.card_details });
//     } else if (result.data.status === 401) {
//       this.setState({ myCards: [] });
//     }

//     this.setState({ showPaymentsOptions: true });
//     // console.log('onOneClickCardsFetch response ', result);
//   };

//   onEnvDataFetch = result => {
//     console.log('env data fetched -------------------', result);

//     if (result && result.data) {
//       this.setState({ envData: result.data });
//     }
//   };

//   getBipCards = () => {
//     this.props.actions
//       .apiCall({
//         url: AppData.BIP_URL + 'api/v1/myCard/' + this.props.data.loginData.id,
//       })
//       .then(
//         res => this.onBipCardsFetchResponse(res),
//         err => this.onBipCardsFetchResponse(err),
//       );
//   };

//   onBipCardsFetchResponse = result => {
//     if (result && result.data && result.data.success && result.data.data) {
//       this.setState({ bipItems: result.data.data });
//     }
//     console.log('Bip cards from api are ', result);
//   };

//   renderMenuItems = (val, i) => {
//     return (
//       <div
//         key={i}
//         className="kupos-card account-general-item pointer"
//         onClick={
//           val.label == 'MY_QR'
//             ? this.props.data.loginData && this.props.data.loginData.identity_type == 7
//               ? () => this.onItemClick(val, i)
//               : () =>
//                   this.setState({
//                     showSuccessFailureModal: true,
//                     showSuccessFailureModalStatus: false,
//                     showSuccessFailureModalBodyText: this.props.t('PROFILE.FUNCTIONALITY_FOR_RUT'),
//                   })
//             : () => this.onItemClick(val, i)
//         }
//       >
//         <div className={'account-general-image-item '}>
//           <img src={val.icon} alt="" />
//         </div>
//         <div>{this.props.t('PROFILE.' + val.label)}</div>
//       </div>
//     );
//   };

//   onItemClick = (val, i) => {
//     if (val.label == 'MY_QR') {
//       this.props.actions.getQr();
//       this.setState({ selectedItem: val });
//     } else if (val.label == 'MY_BIP') {
//       // this.setState({ selectedItem: val });
//       this.setState({ bipComingSoonModal: true });
//     } else if (val.label === 'MY_TRAVELS') {
//       this.props.onMenuChange(1);
//     } else if (val.label == 'ENVIRONMENTAL_EFFECTS') {
//       this.setState({ selectedItem: val });
//     } else if (val.label == 'MY_CARDS') {
//       this.setState({ selectedItem: val });
//     }
//   };

//   renderItemContent = () => {
//     console.log('Selected Item', this.state.selectedItem);
//     if (this.state.selectedItem.label == 'MY_QR') {
//       return this.renderQrImage();
//     } else if (this.state.selectedItem.label == 'MY_BIP') {
//       return this.renderBIP();
//     } else if (this.state.selectedItem.label == 'ENVIRONMENTAL_EFFECTS') {
//       return this.renderEnvironmentalImpact();
//     } else if (this.state.selectedItem.label == 'MY_CARDS') {
//       return this.renderMyCards();
//     }
//   };

//   renderQrImage = () => {
//     return (
//       <div className="my-qr-container">
//         <div className="recharge-wallet-top-strip">
//           <div onClick={() => this.setState({ selectedItem: null })} style={{ paddingTop: 12 }}>
//             <img className="qr-back" src="/images/back_arrow_bip.png" />
//           </div>
//           <div
//             className="sub-section-account-general-title font13 center-text"
//             style={{ paddingTop: 16 }}
//           >
//             <span className="bold-text">{this.props.t('PROFILE.MY_QR')}</span>
//           </div>
//           <div></div>
//         </div>

//         {this.props.data.getQrPending && !this.props.data.qrImage ? (
//           <div></div>
//         ) : this.props.data.qrImage ? (
//           <div className="qr-image">
//             <img src={this.props.data.qrImage.img_src} />
//             <hr />
//             <div className="qr-info flex-row space-between font10">
//               {console.log('Login data ', this.props)}
//               <span>
//                 {this.props.data.loginData.name}
//                 {' ' + this.props.data.loginData.last_name}
//               </span>
//               <span>{this.props.data.loginData.identity_val}</span>
//             </div>
//           </div>
//         ) : this.props.data &&
//           this.props.data.getQrError &&
//           this.props.data.getQrError.data &&
//           this.props.data.getQrError.data.error ? (
//           <div className="trips-error-msg">
//             <span>{this.props.data.getQrError.data.error}</span>
//           </div>
//         ) : null}
//       </div>
//     );
//   };

//   showBipEditPopup = val => {
//     this.setState({ bipCardToEdit: val });
//     setTimeout(() => {
//       this.setState({ showEditBipCard: true });
//     }, 100);
//   };

//   showBipDeletePopup = val => {
//     this.setState({ bipCardToDelete: val });
//     setTimeout(() => {
//       this.setState({ showDeleteBIPCard: true });
//     }, 100);
//   };

//   renderBipRow = (val, key) => {
//     return (
//       <div className="kupos-card bip-row" key={key}>
//         <div className="card-and-card-details">
//           <img src="/images/bip_card.svg" />
//           <div className="bip-card-details font9">
//             <div className="font10 bold-text bip-head">{this.props.t('PROFILE.CARD_NUMBER')}</div>
//             <div className="font9">{val.card_number}</div>
//           </div>
//         </div>

//         <div className="bip-item-border"></div>
//         <div className="bip-card-details-middle">
//           <div className="font10 bold-text bip-head">{this.props.t('PROFILE.NAME')}</div>
//           <div className="font9 ">{val.card_name}</div>
//         </div>
//         <div className="bip-edit-delete-icons">
//           <img onClick={() => this.showBipEditPopup(val)} src="/images/edit_profile.svg" />
//           <img onClick={() => this.showBipDeletePopup(val)} src="/images/delete_card.svg" />
//         </div>
//       </div>
//     );
//   };

//   renderBIPAdministrator = () => {
//     return (
//       <div className="my-bip-container">
//         <div className="bip-rows-container">
//           {this.state.bipItems.map((val, key) => this.renderBipRow(val, key))}
//         </div>
//       </div>
//     );
//   };

//   renderBIPMain = () => {
//     <div className="bip-rows-container-main">
//       <div className="image-holder">
//         <img src="/images/main_card_bip.png" />
//       </div>

//       <div className="bip-sub-body-container">
//         <div className="bip-sub-body-container-inner">
//           <div className="recarge-input-label font10 bold-text">
//             {this.props.t('PROFILE.RECHARGE_AMOUNT')}
//           </div>

//           <KuposInput
//             placeholder="$XXXXX"
//             className="kupos-border font10 bip-recharge-input"
//             // value={this.state.rechargeAmount}
//             // onBlur={() => {}}
//             // onChange={val => this.setState({ rechargeAmount: val })}
//           />

//           <div className="recarge-input-info-footer font8 light-grey-text">
//             {this.props.t('PROFILE.RECHARGE_INPUT_FOOTER')}
//           </div>
//         </div>

//         <div className="bip-recharge-button font12">
//           <KuposButton
//             // onClick={this.onBookButtonPress}
//             className="bip-button-inner"
//           >
//             {this.props.t('PROFILE.RECHARGE_BUTTON')}
//           </KuposButton>
//         </div>
//       </div>
//     </div>;
//   };

//   // renderSingleBipcard = (val, key) => {
//   //   return(

//   //   )
//   // }

//   renderSingleBipcard = card => {
//     console.log('Card is', card);
//     return (
//       <View className="view">
//         {/* <span>{card.name}</span> */}
//         <div
//           style={{
//             marginHorizontal: '15vw',
//             backgroundColor: '#2869be',
//             maxWidth: '20vw',
//             height: '100%',
//             borderRadius: 8,
//             flexDirection: 'column',
//             justifyContent: 'space-between',
//             position: 'relative',
//             margin: 'auto',
//           }}
//         >
//           <div
//             style={{
//               display: 'flex',
//               flexDirection: 'row',
//               justifyContent: 'space-between',
//               padding: 20,
//             }}
//           >
//             <span
//               className="bold-text"
//               white={true}
//               style={{ color: '#fff', fontSize: 18, marginTop: 6 }}
//             >
//               Tarjeta Bip!
//             </span>

//             <img style={{ width: 55, marginTop: 0 }} src={'/images/bip_icon.png'} />
//           </div>

//           <div
//             style={{
//               padding: 20,
//               paddingTop: 25,
//               paddingBottom: 25,
//               display: 'flex',
//               flexDirection: 'column',
//             }}
//           >
//             <span className="bold-text" white={true} style={{ color: '#fff', fontSize: 18 }}>
//               {'N° ' + card.card_number}
//             </span>
//             <span
//               className="bold-text"
//               white={true}
//               style={{ color: '#fff', fontSize: 18, marginTop: 4 }}
//             >
//               {card.card_name}
//             </span>
//           </div>
//         </div>

//         <div
//           style={{
//             position: 'absolute',
//             bottom: 10,
//             display: 'flex',
//             justifyContent: 'center',
//             // backgroundColor: '#f00',
//             width: '35%',
//           }}
//         >
//           {/* {this.state.bipItems.map((val, key) => this.renderDots(key))} */}
//         </div>
//       </View>
//     );
//   };

//   renderDots(key) {
//     console.log('Key is', key);
//     console.log('Card in focus', this.state.cardInFocus);
//     return key == this.state.cardInFocus ? (
//       <div
//         style={{
//           height: 12,
//           width: 12,
//           borderRadius: 7,
//           // backgroundColor: '#fff',
//           borderWidth: 2,
//           borderColor: '#fff',
//           borderStyle: 'solid',
//           marginLeft: 2,
//           marginRight: 2,
//           marginHorizontal: 2,
//           // backgroundColor: "rgba(,0,0,0.6)",
//         }}
//       />
//     ) : (
//       <div
//         style={{
//           height: 8,
//           width: 8,
//           borderRadius: 5,
//           backgroundColor: '#fff',
//           marginHorizontal: 2,
//           marginLeft: 2,
//           marginRight: 2,
//           // backgroundColor: "rgba(,0,0,0.6)",
//         }}
//       />
//     );
//   }

//   onBipRechargeAmountChange = val => {
//     this.setState({ bipRechargeAmount: val, bipRechargeAmountError: null });
//   };

//   onBipRechargeAmountBlur = val => {
//     if (!val) {
//       this.setState({
//         bipRechargeAmountError: {
//           message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT',
//         },
//       });
//     }
//   };

//   goToBipRecharge = () => {
//     if (!this.state.bipRechargeAmount) {
//       this.setState({
//         bipRechargeAmountError: {
//           message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT',
//         },
//       });
//       return;
//     }

//     console.log('amount -----------------', this.state.bipRechargeAmount);

//     if (this.state.bipRechargeAmount < 2000 || this.state.bipRechargeAmount > 25000) {
//       this.setState({
//         bipRechargeAmountError: {
//           message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT_LIMIT',
//         },
//       });
//       return;
//     }
//     console.log('ALL GOOD AND PROPS ARE ', this.props);
//     let data = {
//       cardNumber: this.state.bipItems[this.state.cardInFocus].card_number,
//       amount: this.state.bipRechargeAmount,
//       email: this.state.bipItems[this.state.cardInFocus].email,
//       confirmEmail: this.state.bipItems[this.state.cardInFocus].email,
//       isMyCard: 'my_card',
//     };
//     console.log('Inside bip recharge and data is ', data);
//     this.props.actions.saveBipDetails(data);
//     this.props.history.push('/bip-payment');
//   };

//   renderBIP = () => {
//     return (
//       <div className="my-bip-container">
//         {this.state.bipItems.length > 0 ? (
//           <div className="bip-top-strip">
//             <div
//               className="bip-icon-top back-arrow"
//               onClick={() =>
//                 this.state.bipAdminScreen
//                   ? this.setState({
//                       bipAdminScreen: false,
//                     })
//                   : this.setState({
//                       selectedItem: null,
//                     })
//               }
//             >
//               <img src="/images/back_arrow_bip.png" />
//             </div>

//             <div>
//               <div className="font13 center-text">
//                 {this.state.bipAdminScreen == false ? (
//                   <span>
//                     {this.props.t('PROFILE.BIP_MAIN_TITLE.NORMAL')}
//                     <span className="bold-text bip-top-strip-heading">
//                       {' '}
//                       {this.props.t('PROFILE.BIP_MAIN_TITLE.BOLD')}
//                     </span>
//                   </span>
//                 ) : (
//                   <span>
//                     {this.props.t('PROFILE.BIP_TITLE1.NORMAL')}
//                     <span className="bold-text bip-top-strip-heading">
//                       {this.props.t('PROFILE.BIP_TITLE1.BOLD')}!
//                     </span>
//                   </span>
//                 )}
//               </div>
//               <div className="font11 center-text bip-top-strip-sub-heading">
//                 {this.state.bipAdminScreen == false ? (
//                   <span>{this.props.t('PROFILE.BIP_SUBTITLE')}</span>
//                 ) : (
//                   <span>{this.props.t('PROFILE.BIP_SUBTITLE1')}</span>
//                 )}
//               </div>
//             </div>
//             <div className="bip-icon-top end-bip-icon">
//               {this.state.bipAdminScreen == false ? (
//                 <div className="display-flex">
//                   <img
//                     onClick={() => this.setState({ showAddBIPCard: true })}
//                     src="/images/add_card.svg"
//                   />
//                   <div
//                     className="font9 bip-admin-capsule"
//                     onClick={() => this.setState({ bipAdminScreen: true })}
//                   >
//                     {this.props.t('PROFILE.MANAGE_CARDS')}
//                   </div>
//                 </div>
//               ) : (
//                 <div className="bip-icon-top end-bip-icon end-bip-icon2">
//                   <img
//                     onClick={() => this.setState({ showAddBIPCard: true })}
//                     src="/images/add_card.svg"
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
//         ) : (
//           <div className="bip-top-strip">
//             <div
//               className="bip-icon-top back-arrow"
//               onClick={() => this.setState({ selectedItem: null })}
//             >
//               <img src="/images/back_arrow_bip.png" />
//             </div>
//             <div></div>

//             <div></div>
//           </div>
//         )}

//         {!this.state.bipItems.length > 0 ? (
//           <KuposDataNotFound
//             icon="/images/bip_grey.svg"
//             title={this.props.t('PROFILE.NO_BIP_CARD')}
//             subTitle={this.props.t('PROFILE.MAKE_FIRST_RECHARGE')}
//             infoText={this.props.t('PROFILE.ADD_FIRST_CARD')}
//             onInfoClick={() => this.setState({ showAddBIPCard: true })}
//           />
//         ) : this.state.bipAdminScreen == false ? (
//           <div className="bip-rows-container-main" sty>
//             {/* <div className="image-holder">
//               <img src="/images/main_card_bip.png" />
//             </div> */}

//             {console.log('Track of swiper', this.track)}

//             <div style={{ marginTop: 10, marginBottom: 15, position: 'relative' }}>
//               <ViewPager tag="main">
//                 <Frame className="frame">
//                   <Track
//                     ref={c => (this.track = c)}
//                     viewsToShow={1}
//                     className="track"
//                     onViewChange={e => this.setState({ cardInFocus: e[0] })}
//                   >
//                     {/* <Track ref={c => (this.track = c)} viewsToShow={2} infinite className="track"> */}

//                     {this.state.bipItems.map((val, key) => {
//                       return this.renderSingleBipcard(val, key);
//                     })}
//                   </Track>
//                 </Frame>
//                 <nav
//                   className="pager-controls"
//                   style={{
//                     position: 'absolute',
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     width: '100%',
//                     top: 60,
//                     paddingLeft: 35,
//                     paddingRight: 35,
//                   }}
//                 >
//                   <a
//                     className="pager-control pager-control--prev "
//                     onClick={() => this.track.prev()}
//                   >
//                     <img className="control-icon" src="/images/icons/home/icon_arrow_left.png" />
//                   </a>
//                   <a
//                     className="pager-control pager-control--next"
//                     onClick={() => this.track.next()}
//                   >
//                     <img className="control-icon" src="/images/icons/home/icon_arrow_right.png" />
//                   </a>
//                 </nav>

//                 <div
//                   style={{
//                     position: 'absolute',
//                     bottom: 10,
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     // backgroundColor: '#f00',
//                     width: '100%',
//                   }}
//                 >
//                   {this.state.bipItems.map((val, key) => this.renderDots(key))}
//                 </div>
//               </ViewPager>
//             </div>

//             <div className="bip-sub-body-container">
//               <div className="bip-sub-body-container-inner">
//                 <div className="recarge-input-label font10 bold-text">
//                   {this.props.t('PROFILE.RECHARGE_AMOUNT')}
//                 </div>

//                 <KuposInput
//                   placeholder="$XXXXX"
//                   className="kupos-border font10 bip-recharge-input"
//                   value={this.state.bipRechargeAmount}
//                   onBlur={val => this.onBipRechargeAmountBlur(val)}
//                   onChange={val => this.onBipRechargeAmountChange(val)}
//                   error={this.state.bipRechargeAmountError ? true : false}
//                   errorMessage={
//                     this.state.bipRechargeAmountError
//                       ? this.state.bipRechargeAmountError.message
//                       : ''
//                   }
//                 />

//                 <div className="recarge-input-info-footer font8 light-grey-text">
//                   {this.props.t('PROFILE.RECHARGE_INPUT_FOOTER')}
//                 </div>
//               </div>

//               <div className="bip-recharge-button font12">
//                 <KuposButton onClick={() => this.goToBipRecharge()} className="bip-button-inner">
//                   {this.props.t('PROFILE.RECHARGE_BUTTON')}
//                 </KuposButton>
//               </div>
//             </div>
//           </div>
//         ) : (
//           this.renderBIPAdministrator()
//         )}
//       </div>
//     );
//   };

//   renderEnvironmentalImpact = () => {
//     return (
//       <div className="my-bip-container env-impact-container">
//         <div className="bip-top-strip">
//           <div
//             className="bip-icon-top back-arrow"
//             onClick={() => this.setState({ selectedItem: null })}
//           >
//             <img style={{ marginLeft: '2%' }} src="/images/back_arrow_bip.png" />
//           </div>

//           <div>
//             <div className="font13 center-text">
//               <span>
//                 {this.props.t('PROFILE.ENV_IMPACT.NORMAL')}
//                 <span className="bold-text bip-top-strip-heading">
//                   {this.props.t('PROFILE.ENV_IMPACT.BOLD')}
//                 </span>
//               </span>
//             </div>
//             <div className="font11 center-text bip-top-strip-sub-heading">
//               <span>{this.props.t('PROFILE.ENVIRONMENTAL_IMPACT')}</span>
//             </div>
//           </div>
//           <div></div>
//         </div>

//         <div className="bip-rows-container-main">
//           <div className="env-top-strip kupos-card">
//             <div className="env-top-strip-icon-container">
//               <img className="env-top-strip-icon" src="/images/circular/enfironment.png" />
//             </div>
//             {this.state.titleDescItems.map((val, key) => this.renderTitleDesc(val, key))}
//           </div>

//           {/* <div className="env-impact-body">
//             <div className="movements-in-capsule-menu font10" style={{ marginLeft: '1%' }}>
//               <MonthYearPicker
//                 selectedYear={this.state.selectedYear}
//                 selectedMonth={this.state.selectedMonth}
//                 onMonthChange={this.onMonthChange}
//               ></MonthYearPicker>
//             </div>

//             <div className="env-transactions-body-item env-impact-heading less-bold-text font10">
//               <div className="transactions-first-child" style={{ paddingLeft: 18 }}>
//                 <span className="bold-text ">{this.props.t('PROFILE.DATE')}</span> <br />
//               </div>

//               <div className="vl"></div>

//               <div className="my-movements-middile-item">
//                 <span className="bold-text my-movement-title-span">
//                   {this.props.t('PROFILE.SERVICE_ENV')}
//                 </span>{' '}
//                 <br />
//               </div>

//               <div className="vl"></div>

//               <div>
//                 <div>
//                   <span className="bold-text">{this.props.t('PROFILE.CARBON_FOOTPRINT')}</span>
//                   <br />
//                 </div>
//               </div>
//             </div>

//             {this.state.envItems.map((val, key) => this.renderBodyItem(val, key))}
//           </div> */}
//         </div>
//       </div>
//     );
//   };

//   onMonthChange = (maskedValue, selectedYear, selectedMonth) => {
//     console.log(maskedValue, selectedMonth);

//     this.setState({ selectedYear: selectedYear, selectedMonth: selectedMonth });

//     //  this.loadTransactions(selectedMonth, selectedYear);
//   };

//   renderBodyItem = (val, key) => {
//     return (
//       <div key={key} className="my-account-main-tabs-body-my-transactions  font9">
//         <div className="kupos-card env-transactions-body-item my-movements-heading ">
//           <div
//             style={{ height: '100%', justifyContent: 'space-around' }}
//             className="text-center transactions-first-child"
//           >
//             <span className="bold-text light-grey-text font12">
//               {DateService.getDateFromDate(val.date, 'dd-mm-yyyy')}
//             </span>{' '}
//             {/* <br /> */}
//             <span className="light-grey-text">
//               {DateService.getMonthNameFromDate(val.date, 'dd-mm-yyyy', 'full')}
//             </span>
//           </div>

//           <div className="vl"></div>
//           <div className="flex-row transaction-status">
//             <div className="display-flex" style={{ alignItems: 'center' }}>
//               {/* <div className="env-top-strip-icon-container">
//                 <img className="env-top-strip-icon-inner" src="/images/circular/enfironment.png" />
//               </div> */}
//               <div
//                 style={{
//                   display: 'flex',
//                   flexDirection: 'column',
//                   justifyContent: 'space-around',
//                 }}
//               >
//                 <span className="bold-text font12 light-grey-text" style={{ marginBottom: 10 }}>
//                   {val.service}
//                 </span>
//                 {/* <br /> */}
//                 <span className=" light-grey-text">{val.region}</span>
//               </div>
//             </div>

//             <div
//               className="see-more primary-text  less-bold-text"
//               style={{ marginBottom: 0 }}
//               //  onClick={() => this.onSeeMoreClicked(key)}
//             >
//               <span>{this.props.t('PROFILE.VIEW_MORE')}</span>
//               <span className="flex-right my-movements-subitem">
//                 <img src="/images/icons/home/icon_arrow_down.png" alt="" />
//               </span>
//             </div>
//           </div>

//           <div className="vl"></div>

//           <div>
//             {val.percentage >= 85 ? (
//               <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
//                 <span className="bold-text font12 red-text">
//                   {val.percentage}
//                   {'%'}
//                 </span>{' '}
//               </div>
//             ) : (
//               <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
//                 <span className="bold-text font12 green-text">
//                   {val.percentage}
//                   {'%'}
//                 </span>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* <div
//                          className={
//                            'sub-body-my-trips font10 ' +
//                            (key == this.state.selectedIndex ? 'show' : 'hide')
//                          }
//                        >
//                          <span className="sub-body-my-trips-title font10 primary-text-color bold-text">
//                            {this.props.t('PROFILE.TRANSACTION_DETAILS')}
//                          </span>{' '}
//                          <br />
//                          <div className="sub-body-sub-item">
//                            <div>
//                              <div>
//                                <span className="bold-text font10 light-grey-text">
//                                  {this.props.t('PROFILE.CATEGORY')}
//                                </span>{' '}
//                                <br />
//                                <span className="font10 light-grey-text">
//                                  {val.category_info.label}
//                                </span>
//                              </div>
//                            </div>

//                            <div className="text-right">
//                              <div>
//                                <span className="bold-text font10 light-grey-text">
//                                  {this.props.t('PROFILE.TRANSACTION_NUMBER')}
//                                </span>{' '}
//                                <br />
//                                <span className="font10 light-grey-text">
//                                  {val.category_info.txn_code}
//                                </span>
//                              </div>
//                            </div>
//                          </div>
//                          <hr className="horizontal-line" />
//                          <div>
//                            <span className="bold-text font10 light-grey-text">
//                              {this.props.t('PROFILE.TRANSACTION_DETAILS')}
//                            </span>{' '}
//                            <br />
//                            <span className="font10 light-grey-text">{val.reasons}</span>
//                          </div>
//                          <hr className="horizontal-line" />
//                          <div className="sub-body-sub-item">
//                            <div>
//                              <div>
//                                <span className="bold-text font10 light-grey-text">
//                                  {this.props.t('PROFILE.TRANSACTION_DATE')}
//                                </span>{' '}
//                                <br />
//                                <span className="font10 light-grey-text">
//                                  {' '}
//                                  {DateService.changeDateFormat(
//                                    val.created_date,
//                                    'yyyy-mm-dd',
//                                    'dd/mm/yyyy',
//                                  )}
//                                </span>
//                              </div>
//                            </div>

//                            <div className="text-right">
//                              <div>
//                                <span className="bold-text font10 light-grey-text">
//                                  {this.props.t('PROFILE.TRANSACTION_HOUR')}
//                                </span>{' '}
//                                <br />
//                                <span className="font10 light-grey-text">{val.created_time}</span>
//                              </div>
//                            </div>
//                          </div>
//                        </div> */}
//       </div>
//     );
//   };

//   renderTitleDesc = (val, key) => {
//     return (
//       <div key={key} className="env-strip-text-item">
//         <div>
//           <span className="font10">{this.props.t(val.title)}</span>
//         </div>
//         <div>
//           <span className="font11 bold-text">
//             {key === 0
//               ? this.state.envData && this.state.envData.distance
//                 ? this.state.envData.distance + 'KM'
//                 : '0KM'
//               : key === 1
//               ? (this.state.envData && this.state.envData.carbon + 'M') || '7.3M'
//               : key === 2
//               ? (this.state.envData && this.state.envData.tree + 'M') || '1.23M'
//               : CommonService.currency(this.state.envData && this.state.envData.price) ||
//                 'CLP $6000'}
//           </span>
//         </div>
//       </div>
//     );
//   };

//   renderMyCards = () => {
//     return (
//       <div className="my-bip-container env-impact-container">
//         <div className="bip-top-strip">
//           <div
//             className="bip-icon-top back-arrow"
//             onClick={() => this.setState({ selectedItem: null })}
//           >
//             <img style={{ marginLeft: '2%' }} src="/images/back_arrow_bip.png" />
//           </div>

//           <div>
//             <div className="font13 center-text">
//               <span>
//                 <span className="bold-text bip-top-strip-heading">
//                   {this.props.t('PROFILE.MY_CARDS')}
//                 </span>
//               </span>
//             </div>
//             {/* <div className="font11 center-text bip-top-strip-sub-heading">
//                              <span>{this.props.t('PROFILE.ENVIRONMENTAL_IMPACT')}</span>
//                            </div> */}
//           </div>
//           <div className="my-cards-right-icon">
//             {this.state.myCards.length < 2 && this.state.myCards.length > 0 ? (
//               <img
//                 onClick={() => this.setState({ showCardAddInfoModal: true })}
//                 src="/images/add_card.svg"
//               />
//             ) : null}
//           </div>
//         </div>

//         <div className="my-cards-sub-body">
//           {this.state.myCards && this.state.myCards.length > 0 ? (
//             this.state.myCards.map((val, key) => this.renderMyCard(val, key))
//           ) : (
//             <KuposDataNotFound
//               icon={'/images/no-cards.svg'}
//               title={this.props.t('TRANSLATIONS.NO_CARDS_TITLE')}
//               subTitle={this.props.t('TRANSLATIONS.NO_CARDS_DESC')}
//               infoText={this.props.t('TRANSLATIONS.NO_CARDS_INFO_HINT')}
//               onInfoClick={() => {
//                 this.setState({ showCardAddInfoModal: true });
//               }}
//             />
//           )}
//         </div>
//       </div>
//     );
//   };

//   renderMyCard = (val, key) => {
//     console.log('Card is---------', this.props.data);
//     return (
//       <div key={key} className={'my-cards-main-item kupos-card txn-item'}>
//         <div className={'card-item'}>
//           {/* <img src={val.cardImage} /> */}
//           <img
//             style={{ height: 16 }}
//             src={
//               this.state.cardTypes[val[2]] == 'americanexpress'
//                 ? '/images/cards/americanexpress.png'
//                 : this.state.cardTypes[val[2]] == 'diners'
//                 ? '/images/cards/diners.png'
//                 : this.state.cardTypes[val[2]] == 'magna'
//                 ? '/images/cards/magna.png'
//                 : this.state.cardTypes[val[2]] == 'mastercard'
//                 ? '/images/cards/mastercard.png'
//                 : this.state.cardTypes[val[2]] == 'redcompra'
//                 ? '/images/cards/redcompra.png'
//                 : '/images/cards/visa.png'
//             }
//           />
//           <div className="two-items">
//             <span className="font11 bold-text">{this.props.t('PROFILE.CARD_NUMBER')}</span>
//             <span className="font10" style={{ marginTop: 5 }}>
//               {val[0].replace(/X/gi, '*').substring(8, 12) + ' ' + val[0].substring(12, 16)}
//             </span>
//           </div>
//         </div>
//         <div className="cards-vl"></div>
//         <div className="name-action">
//           <div className="two-items">
//             <span className="font11 bold-text">{this.props.t('HOME.NAME')}</span>
//             <span className="font10">
//               {CommonService.capitalize(
//                 this.props.data &&
//                   this.props.data.loginData &&
//                   this.props.data.loginData.name &&
//                   this.props.data.loginData.last_name &&
//                   this.props.data.loginData.name + ' ' + this.props.data.loginData.last_name,
//               )}
//             </span>
//           </div>
//           <div className="action-buttons">
//             {/* <img
//               src={'/images/edit_profile.svg'}
//               onClick={() =>
//                 this.setState({
//                   showEditCard: true,
//                   selectedItemForEditAddCard: key,
//                 })
//               }
//             /> */}
//             <img
//               style={{ marginRigh: 20 }}
//               src={'/images/delete_card.svg'}
//               onClick={() =>
//                 this.setState({
//                   showDeleteCard: true,
//                   selectedItemForDeletion: val,
//                 })
//               }
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   onAddBipCard = result => {
//     this.setState({ noCards: false });

//     if (result && result.data && result.data.success && result.data.data) {
//       this.getBipCards();
//       this.setState({
//         showAddBIPCard: false,
//         showSuccessFailureModal: true,
//         showSuccessFailureModalStatus: true,
//         showSuccessFailureModalBodyText: 'VALIDATIONS.BIP_CARD_ADDED',
//       });
//     } else {
//       this.setState({
//         showAddBIPCard: false,
//         showSuccessFailureModal: true,
//         showSuccessFailureModalStatus: false,
//         showSuccessFailureModalBodyText:
//           result.data.message == 'Ingresa una tarjeta bip! válida.'
//             ? 'VALIDATIONS.INVALID_BIP_CARD'
//             : result.data.message,
//       });
//     }

//     // console.log('Result from add card in main tabs', result);
//   };

//   onBipCardUpdate = result => {
//     if (result && result.data && result.data.success && result.data.data) {
//       this.getBipCards();
//       this.setState({
//         showEditBipCard: false,
//         showSuccessFailureModal: true,
//         showSuccessFailureModalStatus: true,
//         showSuccessFailureModalBodyText: 'VALIDATIONS.BIP_CARD_UPDATED',
//       });
//     } else {
//       this.setState({
//         showEditBipCard: false,
//         showSuccessFailureModal: true,
//         showSuccessFailureModalStatus: false,
//         showSuccessFailureModalBodyText: result.data.message || 'Failure!',
//       });
//     }
//   };

//   onBipCardDelete = result => {
//     if (result && result.data && result.data.success && result.data.data) {
//       this.getBipCards();
//       this.setState({
//         showDeleteBIPCard: false,
//         showSuccessFailureModal: true,
//         showSuccessFailureModalStatus: true,
//         showSuccessFailureModalBodyText: 'VALIDATIONS.BIP_CARD_REMOVED',
//       });
//     } else {
//       this.setState({
//         showDeleteBIPCard: false,
//         showSuccessFailureModal: true,
//         showSuccessFailureModalStatus: false,
//         showSuccessFailureModalBodyText: result.data.message || 'Failure!',
//       });
//     }
//   };

//   onCardRemoved = result => {
//     this.getOneClickCards();
//     if (result && result.data && result.data.message === 'successfully Removed') {
//       this.setState({
//         showDeleteCard: false,
//         showSuccessFailureModal: true,
//         showSuccessFailureModalStatus: true,
//         showSuccessFailureModalBodyText: 'TRANSLATIONS.CARD_REMOVED_SUCCESS',
//       });
//     } else {
//       this.setState({
//         showDeleteCard: false,
//         showSuccessFailureModal: true,
//         showSuccessFailureModalStatus: false,
//         showSuccessFailureModalBodyText: 'TRANSLATIONS.CARD_REMOVED_FAILURE',
//       });
//     }
//   };

//   addOneClickCard = () => {
//     localStorage.setItem('appType', 'one_click');
//     this.props.actions
//       .apiCall({
//         url: AppData.BASE_URL + 'api/kupos_add_cards',
//         type: 'home',
//         method: 'POST',
//       })
//       .then(
//         res => this.onAddCard(res),
//         err => this.onAddCard(err),
//       );
//   };

//   onAddCard = result => {
//     console.log('onAddCard------------------------', result);

//     if (result && result.data && result.data.html_str) {
//       this.setState({ showCardAddInfoModal: false });
//       localStorage.setItem('paymentGatewayOpened', true);
//       document.write(result.data.html_str);
//     }
//   };

//   render() {
//     // console.log('Bip cards are', this.state.bipItems);
//     // console.log('Env data ------------------------------', this.state.envData);
//     const { t } = this.props;
//     return (
//       <div
//         className={
//           'sub-section-description scroll-style ' +
//           (this.state.selectedItem && this.state.selectedItem.label == 'MY_BIP'
//             ? 'bip-selection-container'
//             : '')
//         }
//       >
//         {this.state.selectedItem === null ? (
//           <div className="my-account-title center-text">
//             <div className="sub-section-account-general-title font13">
//               {t('PROFILE.MY_MENUS_HEADING.NORMAL')}{' '}
//               <span className="bold-text">{t('PROFILE.MY_MENUS_HEADING.BOLD')}</span>
//             </div>
//             <div className="sub-section-account-general-description font11">
//               {t('PROFILE.MY_MENUS_DESCRIPTION')}
//             </div>
//           </div>
//         ) : null}

//         {this.state.selectedItem === null ? (
//           <div className="sub-section-body">
//             <div className="account-general-items font10 bold-text">
//               {this.state.items.map((val, key) => this.renderMenuItems(val, key))}
//             </div>
//           </div>
//         ) : (
//           this.renderItemContent()
//         )}

//         <AddNewCard
//           showModal={this.state.showAddCard}
//           onHide={() => this.setState({ showAddCard: false })}
//           common={this.props.common}
//           onAddCard={() => this.setState({ noCards: false, showAddCard: false })}
//           t={this.props.t}
//         />

//         <EditCard
//           showModal={this.state.showEditCard}
//           onHide={() => this.setState({ showEditCard: false })}
//           userCards={this.state.myCards}
//           selectedItemForEdit={this.state.selectedItemForEditAddCard}
//           t={this.props.t}
//         />

//         <DeleteCard
//           showModal={this.state.showDeleteCard}
//           onHide={() => this.setState({ showDeleteCard: false })}
//           userCards={this.state.myCards}
//           selectedItemForDeletion={this.state.selectedItemForDeletion}
//           // common={this.props.common}
//           data={this.props.data}
//           actions={this.props.actions}
//           t={this.props.t}
//           onCardRemoved={this.onCardRemoved}
//         />

//         <BipComingSoonModal
//           showModal={this.state.bipComingSoonModal}
//           onHide={() => this.setState({ bipComingSoonModal: false })}
//           image={t('HOME.BIP_SOON_IMAGE')}
//           metaData={this.props.metaData}
//         />

//         <AddNewBipCard
//           showModal={this.state.showAddBIPCard}
//           onHide={() => this.setState({ showAddBIPCard: false })}
//           common={this.props.common}
//           onAddCard={this.onAddBipCard}
//           actions={this.props.actions}
//           data={this.props.data}
//           // metaData={this.props.metaData}
//           t={this.props.t}
//         />

//         {this.state.bipCardToEdit ? (
//           <EditBipCard
//             showModal={this.state.showEditBipCard}
//             onHide={() => this.setState({ showEditBipCard: false })}
//             userCards={this.state.bipItems}
//             selectedItemForEdit={this.state.bipCardToEdit}
//             // common={this.props.common}
//             onBipCardUpdate={this.onBipCardUpdate}
//             data={this.props.data}
//             actions={this.props.actions}
//             t={this.props.t}
//           />
//         ) : null}

//         {this.state.bipCardToDelete ? (
//           <DeleteBipCard
//             showModal={this.state.showDeleteBIPCard}
//             onHide={() => this.setState({ showDeleteBIPCard: false })}
//             userCards={this.state.bipItems}
//             selectedItemForDeletion={this.state.bipCardToDelete}
//             // common={this.props.common}
//             onBipCardDelete={this.onBipCardDelete}
//             data={this.props.data}
//             actions={this.props.actions}
//             t={this.props.t}
//           />
//         ) : null}

//         <KuposErrorSuccessModal
//           success={this.state.showSuccessFailureModalStatus}
//           showModal={this.state.showSuccessFailureModal}
//           title={
//             this.state.showSuccessFailureModalStatus
//               ? this.props.t('HOME.THANK_YOU')
//               : this.props.t('HOME.WE_ARE_SORRY')
//           }
//           onButtonClick={() => this.setState({ showSuccessFailureModal: false })}
//           bodyText={this.state.showSuccessFailureModalBodyText}
//           t={this.props.t}
//           generalButton={
//             this.state.showSuccessFailureModalStatus
//               ? this.props.t('OK')
//               : this.props.t('PROFILE.GO_BACK')
//           }
//         />

//         <AddCardInfoModal
//           showModal={this.state.showCardAddInfoModal}
//           onHide={() => this.setState({ showCardAddInfoModal: false })}
//           icon={'/images/warning.png'}
//           t={this.props.t}
//           addCard={this.addOneClickCard}
//         />
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/MainTabsBodyMyAccount.js